import { useEffect } from "react";
import { useQuery } from "react-query";
import { TreatmentSummaryProto } from "@noom/noom-contracts/noom_contracts/healthcare/model/treatment";
import { captureException } from "src/utils/error";
import { getNonTerminalTreatments } from "src/funnels/insurance-reimbursement/requests/getNonTerminalTreatments";
import { handleTelehealthRequestError } from "src/utils/api/telehealth";

export const nonTerminalTreatmentsQueryKey = (
  accessCode: string | null | undefined
) => ["getNonTerminalTreatments", accessCode];

export default function useNonTerminalTreatments({
  accessCode,
  enabled = true,
}: {
  accessCode: string | null | undefined;
  enabled?: boolean;
}) {
  const { isLoading, error, data } = useQuery({
    queryKey: nonTerminalTreatmentsQueryKey(accessCode),
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    queryFn: () => getNonTerminalTreatments(accessCode!),
    enabled: enabled && !!accessCode,
  });

  useEffect(() => {
    if (error) {
      handleTelehealthRequestError("getNonTerminalTreatments", error);
      captureException(error);
    }
  }, [error]);

  return {
    isLoadingTreatments: isLoading,
    treatmentsError: error,
    treatments: (data?.treatments ?? []) as TreatmentSummaryProto[],
  };
}
